module.exports = __webpack_public_path__ + "img/imepaylogo.c1b3ffa1.svg";